
<template>
  <div>
    <b-card class="body-card" header-bg-variant="light">
      <b-card-header class="card-header-wrapper">
        <div class="title-wrapper" style="grid-template-columns: 3fr 2fr 1fr 1fr;">
          <span class="brand-title-header">
            ImpaxRx PAP Drug Management
            <span class="sub-header">&nbsp;> By Brand</span>
          </span>
          <div class="brand-add-wrapper ml-2">
            <b-button
              variant="success"
              @click="$router.push(`/drugDatabase/brandName/add`)"
            >Add Drug</b-button>
          </div>
          <div class="btn-filter-wrapper">
            <b-button @click="clearFilter" class="btn-filters">Clear filters</b-button>
            <b-button @click="exportToCsv" class="btn-csv">Export to CSV</b-button>
          </div>
          <download-csv
            v-if="brandNameRecords"
            style="visibility :hidden"
            name="brandNameRecords.csv"
            ref="exportCsv"
            :data="brandNameRecords"
          >Export to CSV</download-csv>
        </div>
      </b-card-header>
      <b-card-body class="card-body-wrapper">
        <b-card class="card-wrapper" header-bg-variant="dark" header="Drug Management">
          <grid
            has-pagination
            :has-clear="false"
            grid-id="drug-brand-grid"
            :fields="fields"
            :items="brandNameRecords"
            :filters="filtersObjArr"
            :get-items-function="getBrandNameRecordsFromApi"
            :total-rows="paging.totalItems"
            :current-page="paging.pageNumber"
            :per-page="paging.pageSize"
            :sort-by="paging.sortBy"
            :no-records="'No associated records found'"
            :sort-order="paging.sortOrder"
            ref="drugBrandGridRef"
            @click-row="onRowClick($event)"
          />
        </b-card>
      </b-card-body>
    </b-card>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import _ from 'lodash';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { router } from '@/router';
import Grid from '@/shared/components/Grid';
import { IRX_ELIGIBLE_OPTIONS } from '@/shared/constants';
import { removeTimeFromDate } from '@/shared/utils';

export default Vue.extend({
  name: 'BrandName',
  components: { Grid },
  data() {
    return {
      fields: [
        {
          key: 'brand',
          label: 'Brand',
          tdClass: 'txt-link'
        },
        {
          key: 'isPAPI',
          label: 'ImpaxPAP',
          tdClass: (value, key, item) => {
            return item.isPAPI.toLowerCase() === 'yes'
              ? 'table-success'
              : 'table-danger';
          }
        },
        { key: 'shortDuration', label: 'Short Duration' },
        { key: 'startd', label: 'Start Date' },
        {
          key: 'endDate',
          label: 'End Date',
          formatter: value => {
            return removeTimeFromDate(value);
          }
        },
        { key: 'edate', label: 'Expires Date' },
        {
          key: 'expiresAtReEnrollment',
          label: 'Expires @ ReEnroll'
        },
        { key: 'comment', label: 'Comment' }
      ],
      filtersObjArr: [
        {
          type: 'search',
          name: '',
          fieldName: 'brand',
          placeholder: 'Search By Brand'
        },
        {
          type: 'select',
          name: '',
          fieldName: 'isPAPI',
          value: IRX_ELIGIBLE_OPTIONS.YES,
          width: '100px',
          options: [
            { value: '', text: 'Select' },
            { value: IRX_ELIGIBLE_OPTIONS.ALL, text: 'All' },
            { value: IRX_ELIGIBLE_OPTIONS.YES, text: 'Yes' },
            { value: IRX_ELIGIBLE_OPTIONS.NO, text: 'No' }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapState('brandName', ['brandNameRecords', 'paging'])
  },
  watch: {},
  methods: {
    ...mapActions('brandName', [
      'getBrandNameRecords',
      'resetDrugBrandPagingState'
    ]),

    onRowClick(item) {
      router.push(`/drugDatabase/brandName/edit/${item.brandId}`);
    },

    removeTimeFromEndDate(endDate) {
      return removeTimeFromDate(endDate);
    },

    async getBrandNameRecordsFromApi(pagingData) {
      await this.getBrandNameRecords(pagingData);
    },

    async clearFilter() {
      await this.$refs['drugBrandGridRef'].onClearSearch();
    },

    exportToCsv() {
      this.$refs.exportCsv.$el.click();
    }
  },
  created() {
    this.resetDrugBrandPagingState();
  }
});
</script>
<style scoped>
.brand-title-header {
  font-size: 1.2rem;
  grid-column: 1/2;
  align-self: center;
}
.brand-add-wrapper {
  grid-column: 2/3;
}
</style>